import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'mchq44',
  Description:
    'Here\'s all the online content included with your <strong>GCSE Maths Exam Practice Workbook</strong>.',
  Credits:
  '<i> <br /> Clipart from Corel®</i>' +
    '<i> <br /> <br />Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</i>',};